import Model from "../model";
import { NormalizedModel } from "../utils/normalized/types";

export const ModelType = "ADDRESS";

export default class Address extends Model {
  // Attributes
  id: string = "";
  name: string = "";
  line1: string = "";
  line2: string = "";
  city: string = "";
  state: string = "";
  postalCode: string = "";
  country: string = "";

  constructor(attributes: { [key: string]: any }) {
    super();
    this.addAttributes(attributes);
  }

  deserialize(input: NormalizedModel) {
    this.id = input.id;
    this.addAttributes(input.attributes);
  }
}
